module.exports = require('./dist/cleave-react-node.js');



/*****************
 ** WEBPACK FOOTER
 ** ./~/cleave.js/react.js
 ** module id = 1234
 ** module chunks = 0
 **/